import { html, LitElement, unsafeCSS } from 'lit';

import { q1MarkdownStyles } from './q1-markdown-styles.js';

import '../../components/zero-md/zero-md.js';


export class Q1Markdown extends LitElement {
  static styles = [ q1MarkdownStyles ];

  static properties = {
    /** Markdown content to render. */
    content: { type: String },

    /**
     * The variant to use for the markdown.
     * - `default`: Default variant
     * - `text`: Text-only version
     */
    variant: { type: String, reflect: true },
  };

  constructor() {
    super();

    this.content = '';
    this.variant = 'default';
  }

  render() {
    if (this.variant === 'text') return html`
      <zero-md>
        <script type="text/markdown">${this.content}</script>

        <template>
          <style>
            .markdown-body {
              background: transparent;
              color: var(--gray-9);
            }
            .markdown-body h1,
            .markdown-body h2,
            .markdown-body h3,
            .markdown-body h4,
            .markdown-body h5,
            .markdown-body h6 {
              color: var(--gray-9);
              font-weight: 600;
              font-size: 1rem;
              line-height: 1.2em;
            }

            .markdown-body a,
            .markdown-body a:visited,
            .markdown-body a:focus,
            .markdown-body a:hover {
              color: var(--gray-9);
              text-decoration: none;
            }
          </style>
        </template>
      </zero-md>
    `;

    return html`
      <zero-md>
        <script type="text/markdown">${this.content}</script>

        <template data-append>
          <style>
            .markdown-body {
              background: transparent;
              color: var(--gray-9);
            }
          </style>
        </template>
      </zero-md>
    `;
  }
}

customElements.define('q1-markdown', Q1Markdown);

